/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ComponentProps, ReactNode } from "react";
import { When } from "react-if";
import { Navigation, Popover, SVGIcon, Text, theme } from "@nordcloud/gnui";
import { isNotNil, PathName } from "~/tools";

type Item = {
  label: string;
  onClick: () => void;
  iconColor?: ComponentProps<typeof SVGIcon>["color"];
  color?: ComponentProps<typeof Text>["color"];
  icon?: PathName;
  disabled?: boolean;
};

type Props = {
  items: Item[];
  trigger: ReactNode;
};

export function PopoverControls({ items, trigger }: Props) {
  return (
    <Popover alignRight trigger={trigger}>
      <Navigation.Container popoverMenu>
        {items.map((item) => (
          <Navigation.Item
            key={item.label}
            css={{
              cursor: item.disabled ? "not-allowed" : "cursor",
              userSelect: "none",
            }}
            onClick={item.disabled ? undefined : item.onClick}
          >
            <When condition={isNotNil(item.icon)}>
              <SVGIcon
                name={item.icon as PathName}
                size="sm"
                color={item.iconColor}
                css={disabledStyle(item.disabled)}
              />
            </When>
            <Text tag="span" css={disabledStyle(item.disabled)} color={item.color}>
              {item.label}
            </Text>
          </Navigation.Item>
        ))}
      </Navigation.Container>
    </Popover>
  );
}

const disabledStyle = (disabled = false) =>
  disabled
    ? {
        fill: theme.color.interactive.disabled,
        color: theme.color.interactive.disabled,
      }
    : {};
